/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-factory.js to modify the generation of this file.
import Accordion from '../components/Accordion';
import ArticleHeading from '../components/ArticleHeading';
import ArticleHero from '../components/ArticleHero';
import AutoloadContentRow from '../components/AutoloadContentRow';
import BioEducation from '../components/BioEducation';
import BioProfessionalInvolvement from '../components/BioProfessionalInvolvement';
import BioProfileHero from '../components/BioProfileHero';
import BioQuote from '../components/BioQuote';
import BioRelatedArticleList from '../components/BioRelatedArticleList';
import Button from '../components/Button';
import ButtonLink from '../components/ButtonLink';
import Carousel from '../components/Carousel';
import ColumnGrid from '../components/ColumnGrid';
import ContactCard from '../components/ContactCard';
import ContactCardManual from '../components/ContactCardManual';
import ContactCards from '../components/ContactCards';
import ContentCard from '../components/ContentCard';
import ContentCardRow from '../components/ContentCardRow';
import ContextContactCards from '../components/ContextContactCards';
import ContextFeatureList from '../components/ContextFeatureList';
import ContextLinkList from '../components/ContextLinkList';
import ContextRichText from '../components/ContextRichText';
import ContextTagList from '../components/ContextTagList';
import Dropdown from '../components/Dropdown';
import EventSearchBar from '../components/EventSearchBar';
import EventSearchResults from '../components/EventSearchResults';
import ExpertiseFeaturedWorkList from '../components/ExpertiseFeaturedWorkList';
import ExpertiseHero from '../components/ExpertiseHero';
import ExpertisePageLinks from '../components/ExpertisePageLinks';
import ExpertisePageLinksContainer from '../components/ExpertisePageLinksContainer';
import ExpertisePageLinksItem from '../components/ExpertisePageLinksItem';
import FeaturedContent from '../components/FeaturedContent';
import FeaturedList from '../components/FeaturedList';
import FeaturedListItem from '../components/FeaturedListItem';
import Footer from '../components/Footer';
import FooterContactBar from '../components/FooterContactBar';
import FooterLinkList from '../components/FooterLinkList';
import FooterTeaser from '../components/FooterTeaser';
import Footnotes from '../components/Footnotes';
import FootnotesItem from '../components/FootnotesItem';
import GeneralHero from '../components/GeneralHero';
import GeneralLandingSearchBar from '../components/GeneralLandingSearchBar';
import Grid from '../components/Grid';
import HeadingAccent from '../components/HeadingAccent';
import HomepageHero from '../components/HomepageHero';
import HorizontalRule from '../components/HorizontalRule';
import IconDropdown from '../components/IconDropdown';
import Image from '../components/Image';
import InPageNavigation from '../components/InPageNavigation';
import InPageNavigationItem from '../components/InPageNavigationItem';
import InteractiveMap from '../components/InteractiveMap';
import ItemWithIcon from '../components/ItemWithIcon';
import ItemWithImage from '../components/ItemWithImage';
import KnowledgeHubDate from '../components/KnowledgeHubDate';
import KnowledgeHubHero from '../components/KnowledgeHubHero';
import Link from '../components/Link';
import LinkList from '../components/LinkList';
import LinkListItem from '../components/LinkListItem';
import MegaNavHeader from '../components/MegaNavHeader';
import MegaNavHome from '../components/MegaNavHome';
import MegaNavPrimary from '../components/MegaNavPrimary';
import MegaNavSecondary from '../components/MegaNavSecondary';
import MegaNavTertiary from '../components/MegaNavTertiary';
import NavBarMain from '../components/NavBarMain';
import Navigation from '../components/Navigation';
import NewsCard from '../components/NewsCard';
import NewsCardRow from '../components/NewsCardRow';
import OfficeCard from '../components/OfficeCard';
import PartialContainer from '../components/PartialContainer';
import ProfileHero from '../components/ProfileHero';
import ProjectMapContainer from '../components/ProjectMapContainer';
import ProjectMapList from '../components/ProjectMapList';
import ProjectMapSearchBar from '../components/ProjectMapSearchBar';
import ProjectMapWorkArticleTable from '../components/ProjectMapWorkArticleTable';
import ProjectMapWorkArticleTableDivider from '../components/ProjectMapWorkArticleTableDivider';
import ProjectMapWorkArticleTableRow from '../components/ProjectMapWorkArticleTableRow';
import ProjectMapWorkTable from '../components/ProjectMapWorkTable';
import QuarterlyAnimationSection from '../components/QuarterlyAnimationSection';
import QuarterlyArticleNavigationBanner from '../components/QuarterlyArticleNavigationBanner';
import QuarterlyIntroduction from '../components/QuarterlyIntroduction';
import QuarterlyIntroductionAnimation from '../components/QuarterlyIntroductionAnimation';
import QuarterlyIntroductionListItem from '../components/QuarterlyIntroductionListItem';
import QuarterlyLandingHero from '../components/QuarterlyLandingHero';
import QuarterlyLandingHeroAnimation from '../components/QuarterlyLandingHeroAnimation';
import QuarterlyNavigation from '../components/QuarterlyNavigation';
import QuarterlySectionHeader from '../components/QuarterlySectionHeader';
import Quote from '../components/Quote';
import RepresentativeWork from '../components/RepresentativeWork';
import RepresentativeWorkFilter from '../components/RepresentativeWorkFilter';
import RichText from '../components/RichText';
import SearchBar from '../components/SearchBar';
import SearchBarFilter from '../components/SearchBarFilter';
import SearchInput from '../components/SearchInput';
import SearchResults from '../components/SearchResults';
import Section from '../components/Section';
import SectionHeading from '../components/SectionHeading';
import SideNavigation from '../components/SideNavigation';
import SideNavigationItem from '../components/SideNavigationItem';
import SimpleHero from '../components/SimpleHero';
import SnippetComponent from '../components/SnippetComponent';
import SocialMediaLinks from '../components/SocialMediaLinks';
import Statistics from '../components/Statistics';
import StickySideBanner from '../components/StickySideBanner';
import StickySideSection from '../components/StickySideSection';
import StudentProfile from '../components/StudentProfile';
import Tag from '../components/Tag';
import TagList from '../components/TagList';
import Text from '../components/Text';
import TwoColStickySideBanner from '../components/TwoColStickySideBanner';
import TwoColumnProfileList from '../components/TwoColumnProfileList';
import TwoColumnProfileListItem from '../components/TwoColumnProfileListItem';
import Video from '../components/Video';

const components = new Map();
components.set('Accordion', Accordion);
components.set('ArticleHeading', ArticleHeading);
components.set('ArticleHero', ArticleHero);
components.set('AutoloadContentRow', AutoloadContentRow);
components.set('BioEducation', BioEducation);
components.set('BioProfessionalInvolvement', BioProfessionalInvolvement);
components.set('BioProfileHero', BioProfileHero);
components.set('BioQuote', BioQuote);
components.set('BioRelatedArticleList', BioRelatedArticleList);
components.set('Button', Button);
components.set('ButtonLink', ButtonLink);
components.set('Carousel', Carousel);
components.set('ColumnGrid', ColumnGrid);
components.set('ContactCard', ContactCard);
components.set('ContactCardManual', ContactCardManual);
components.set('ContactCards', ContactCards);
components.set('ContentCard', ContentCard);
components.set('ContentCardRow', ContentCardRow);
components.set('ContextContactCards', ContextContactCards);
components.set('ContextFeatureList', ContextFeatureList);
components.set('ContextLinkList', ContextLinkList);
components.set('ContextRichText', ContextRichText);
components.set('ContextTagList', ContextTagList);
components.set('Dropdown', Dropdown);
components.set('EventSearchBar', EventSearchBar);
components.set('EventSearchResults', EventSearchResults);
components.set('ExpertiseFeaturedWorkList', ExpertiseFeaturedWorkList);
components.set('ExpertiseHero', ExpertiseHero);
components.set('ExpertisePageLinks', ExpertisePageLinks);
components.set('ExpertisePageLinksContainer', ExpertisePageLinksContainer);
components.set('ExpertisePageLinksItem', ExpertisePageLinksItem);
components.set('FeaturedContent', FeaturedContent);
components.set('FeaturedList', FeaturedList);
components.set('FeaturedListItem', FeaturedListItem);
components.set('Footer', Footer);
components.set('FooterContactBar', FooterContactBar);
components.set('FooterLinkList', FooterLinkList);
components.set('FooterTeaser', FooterTeaser);
components.set('Footnotes', Footnotes);
components.set('FootnotesItem', FootnotesItem);
components.set('GeneralHero', GeneralHero);
components.set('GeneralLandingSearchBar', GeneralLandingSearchBar);
components.set('Grid', Grid);
components.set('HeadingAccent', HeadingAccent);
components.set('HomepageHero', HomepageHero);
components.set('HorizontalRule', HorizontalRule);
components.set('IconDropdown', IconDropdown);
components.set('Image', Image);
components.set('InPageNavigation', InPageNavigation);
components.set('InPageNavigationItem', InPageNavigationItem);
components.set('InteractiveMap', InteractiveMap);
components.set('ItemWithIcon', ItemWithIcon);
components.set('ItemWithImage', ItemWithImage);
components.set('KnowledgeHubDate', KnowledgeHubDate);
components.set('KnowledgeHubHero', KnowledgeHubHero);
components.set('Link', Link);
components.set('LinkList', LinkList);
components.set('LinkListItem', LinkListItem);
components.set('MegaNavHeader', MegaNavHeader);
components.set('MegaNavHome', MegaNavHome);
components.set('MegaNavPrimary', MegaNavPrimary);
components.set('MegaNavSecondary', MegaNavSecondary);
components.set('MegaNavTertiary', MegaNavTertiary);
components.set('NavBarMain', NavBarMain);
components.set('Navigation', Navigation);
components.set('NewsCard', NewsCard);
components.set('NewsCardRow', NewsCardRow);
components.set('OfficeCard', OfficeCard);
components.set('PartialContainer', PartialContainer);
components.set('ProfileHero', ProfileHero);
components.set('ProjectMapContainer', ProjectMapContainer);
components.set('ProjectMapList', ProjectMapList);
components.set('ProjectMapSearchBar', ProjectMapSearchBar);
components.set('ProjectMapWorkArticleTable', ProjectMapWorkArticleTable);
components.set('ProjectMapWorkArticleTableDivider', ProjectMapWorkArticleTableDivider);
components.set('ProjectMapWorkArticleTableRow', ProjectMapWorkArticleTableRow);
components.set('ProjectMapWorkTable', ProjectMapWorkTable);
components.set('QuarterlyAnimationSection', QuarterlyAnimationSection);
components.set('QuarterlyArticleNavigationBanner', QuarterlyArticleNavigationBanner);
components.set('QuarterlyIntroduction', QuarterlyIntroduction);
components.set('QuarterlyIntroductionAnimation', QuarterlyIntroductionAnimation);
components.set('QuarterlyIntroductionListItem', QuarterlyIntroductionListItem);
components.set('QuarterlyLandingHero', QuarterlyLandingHero);
components.set('QuarterlyLandingHeroAnimation', QuarterlyLandingHeroAnimation);
components.set('QuarterlyNavigation', QuarterlyNavigation);
components.set('QuarterlySectionHeader', QuarterlySectionHeader);
components.set('Quote', Quote);
components.set('RepresentativeWork', RepresentativeWork);
components.set('RepresentativeWorkFilter', RepresentativeWorkFilter);
components.set('RichText', RichText);
components.set('SearchBar', SearchBar);
components.set('SearchBarFilter', SearchBarFilter);
components.set('SearchInput', SearchInput);
components.set('SearchResults', SearchResults);
components.set('Section', Section);
components.set('SectionHeading', SectionHeading);
components.set('SideNavigation', SideNavigation);
components.set('SideNavigationItem', SideNavigationItem);
components.set('SimpleHero', SimpleHero);
components.set('SnippetComponent', SnippetComponent);
components.set('SocialMediaLinks', SocialMediaLinks);
components.set('Statistics', Statistics);
components.set('StickySideBanner', StickySideBanner);
components.set('StickySideSection', StickySideSection);
components.set('StudentProfile', StudentProfile);
components.set('Tag', Tag);
components.set('TagList', TagList);
components.set('Text', Text);
components.set('TwoColStickySideBanner', TwoColStickySideBanner);
components.set('TwoColumnProfileList', TwoColumnProfileList);
components.set('TwoColumnProfileListItem', TwoColumnProfileListItem);
components.set('Video', Video);

export default function componentFactory(componentName) {
  return components.get(componentName);
};
